<template>
  <div id="app" class="news" data-page="news">
    <div class="news-wrap">
      <div class="news-title">公告</div>
      <div class="news-menu__list-wrap">
        <ul class="news-menu__list" id="news_menus_map">
          <li class="news-menu__li current" data-menu="all">ALL</li>
        </ul>
      </div>
      <div class="news-content__list-wrap">
        <ul class="news-content__list">
          <li class="news-content__li">
            <a
              href="javascript:;"
              class="news-content__link news-content__link--skt"
            >
              <div class="news-content__info news-content__info--skt">
                <span
                  class="news-content__info-time news-content__info-time--skt"
                ></span>
                <span
                  class="news-content__info-text news-content__info-text--skt"
                ></span>
              </div>
              <div class="news-content__title">
                <span
                  class="news-content__title-text news-content__title-text--skt"
                ></span>
              </div>
            </a>
          </li>
          <li class="news-content__li">
            <a
              href="javascript:;"
              class="news-content__link news-content__link--skt"
            >
              <div class="news-content__info news-content__info--skt">
                <span
                  class="news-content__info-time news-content__info-time--skt"
                ></span>
                <span
                  class="news-content__info-text news-content__info-text--skt"
                ></span>
              </div>
              <div class="news-content__title">
                <span
                  class="news-content__title-text news-content__title-text--skt"
                ></span>
              </div>
            </a>
          </li>
          <li class="news-content__li">
            <a
              href="javascript:;"
              class="news-content__link news-content__link--skt"
            >
              <div class="news-content__info news-content__info--skt">
                <span
                  class="news-content__info-time news-content__info-time--skt"
                ></span>
                <span
                  class="news-content__info-text news-content__info-text--skt"
                ></span>
              </div>
              <div class="news-content__title">
                <span
                  class="news-content__title-text news-content__title-text--skt"
                ></span>
              </div>
            </a>
          </li>
          <li class="news-content__li">
            <a
              href="javascript:;"
              class="news-content__link news-content__link--skt"
            >
              <div class="news-content__info news-content__info--skt">
                <span
                  class="news-content__info-time news-content__info-time--skt"
                ></span>
                <span
                  class="news-content__info-text news-content__info-text--skt"
                ></span>
              </div>
              <div class="news-content__title">
                <span
                  class="news-content__title-text news-content__title-text--skt"
                ></span>
              </div>
            </a>
          </li>
          <li class="news-content__li">
            <a
              href="javascript:;"
              class="news-content__link news-content__link--skt"
            >
              <div class="news-content__info news-content__info--skt">
                <span
                  class="news-content__info-time news-content__info-time--skt"
                ></span>
                <span
                  class="news-content__info-text news-content__info-text--skt"
                ></span>
              </div>
              <div class="news-content__title">
                <span
                  class="news-content__title-text news-content__title-text--skt"
                ></span>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <a href="javascript:;" class="news-more__btn">MORE</a>
    </div>
  </div>
</template>
<script>
import { articlenNews } from "@api/index";
import { VUE_APP_API_URL } from "@utils/index";

export default {
  name: "NewsDetail",
  components: {},
  data() {
    return {
      small: "",
      titleOne: "",
      titleTwo: "",
      titleThree: "",
      titleFour: "",
      titleId: 0,
      baseUrl: VUE_APP_API_URL,
      dataInput: {
        Kind: 2,
        Page: 1,
        PageSize: "5",
        method: "4",
        toAll: "1"
      },
      page: 1,
      moreCurrent: 1,
      totalPage: 0,
      class_id: 2
    };
  },
  mounted: function() {
    window.$("#LT_age").remove();
    let that = this;
    that.initData();
    this.$("body").on("click", ".news-more__btn", function() {
      that.page += 1;
      that.moreCurrent += 1;
      if (that.moreCurrent >= that.totalPage) {
        that.$.gbox.open("沒有下一頁了!", {
          addClass: "default",
          hasCloseBtn: true
        });
        return;
      }
      var newsType = that.$(".news-menu__li.current").attr("data-menu");
      if (newsType == "all") {
        that.dataInput = {
          Kind: 2,
          Page: that.page,
          PageSize: "5",
          method: "4",
          toAll: "1"
        };
      } else {
        that.dataInput = {
          Kind: that.class_id,
          Page: that.page,
          PageSize: "5",
          method: "3",
          toAll: "0"
        };
      }

      that.initData("add");
      that.$(".news-more__btn").remove();
    });
  },
  methods: {
    initData(e) {
      const that = this;
      articlenNews({
        ...that.dataInput,
        class_id: that.dataInput.Kind,
        page: that.Page
      }).then(res => {
        const newsListData = res.new_list;
        console.log(that.dataInput);
        if (String(that.dataInput.Kind) == "2") {
          let that = this;
          var categorylist = ["event", "update", "important", "locale"];
          for (var i = 0; i < res.sun_category_list.length; i++) {
            res.sun_category_list[i].class_id = Number(
              res.sun_category_list[i].class_id
            );
          }
          var sun_category_list = res.sun_category_list;
          console.log(sun_category_list);
          // eslint-disable-next-line no-redeclare
          for (var i = 0; i < sun_category_list.length; i++) {
            // console.log(sun_category_list[i].class_name);
            if (i == 0) {
              that.titleOne = sun_category_list[0].class_name;
              console.log(that.titleOne);
            } else if (i == 1) {
              that.titleTwo = sun_category_list[1].class_name;
              console.log(that.titleTwo);
            } else if (i == 2) {
              that.titleThree = sun_category_list[2].class_name;
              console.log(that.titleThree);
            } else if (i == 3) {
              that.titleFour = sun_category_list[3].class_name;
              console.log(that.titleFour);
            }
          }
          var _HTML_category = `<li class="news-menu__li current" data-menu="all">全部</li>`;
          sun_category_list.forEach(function(v, i) {
            // let that = this;
            _HTML_category += `
                            <li class="news-menu__li" data-class_id="${
                              v.class_id
                            }" data-menu="${
              categorylist[i % categorylist.length]
            }">${v.class_name}</li>`;
            console.log(v.class_name);
            console.log(v.class_id);
          });
          that.$("#news_menus_map").html(_HTML_category);
          that.$(".news-menu__li").on("click", function() {
            that.page = 1;
            that.moreCurrent = 1;
            var newsType = that.$(this).attr("data-menu");
            let class_id = Number(that.$(this).attr("data-class_id"));
            console.log(class_id);
            that
              .$(this)
              .addClass("current")
              .siblings()
              .removeClass("current");

            if (newsType == "all") {
              that.dataInput = {
                Kind: 2,
                Page: "1",
                PageSize: "5",
                method: "4",
                toAll: "1"
              };
            } else {
              that.dataInput = {
                Kind: class_id,
                Page: that.page,
                PageSize: "5",
                method: "3",
                toAll: "0"
              };
            }
            that.initData();
          });
        }
        var newsList;

        if (!newsListData) {
          //   that.$(".news-content__list").html(dataErr("暫無公告資料"));
          that.$(".news-more__btn").removeClass("show");
          return;
        }
        var newsTotalPage = res.total_page;

        newsList = newsListData.map(e => {
          return {
            bullentinCatId: e.class_id,
            bullentinId: e.content_id,
            bullentinRootId: "",
            endDate: "",
            mainPicture: null,
            startDate: e.create_time,
            thumbnail: null,
            title: e.title,
            urlLink: null
          };
        });

        if (newsTotalPage > 1) {
          that.totalPage = newsTotalPage;
          if (that.$(".news-more__btn").length == 0) {
            that
              .$(".news-wrap")
              .append(
                '<a href="javascript:;" class="news-more__btn show">MORE</a>'
              );
          }

          that.$(".news-more__btn").addClass("show");
        }
        var HTML = "";
        newsList.forEach(function(v) {
          HTML += that.newsRender("news", v, e);
        });

        if (e) {
          that.$(".news-content__list").append(HTML);
          that.$(".news-content__li").animate({ opacity: 1 }, 500);
        } else {
          that.$(".news-content__list").html(HTML);
        }
      });
    },
    newsType(type) {
      switch (type) {
        case 3:
          return {
            text: "新闻",
            class: "news-event"
          };
        case 4:
          return {
            text: "公告",
            class: "news-update"
          };
        case 5:
          return {
            text: "活动",
            class: "news-important"
          };

        case 6:
          return {
            text: "攻略",
            class: "news-locale"
          };
        default:
          return {
            text: "其他公告",
            class: "news-error"
          };
      }
    },
    newsRender(page, data, action) {
      let that = this;
      console.log(page, data, action);
      var SData = data.startDate.slice(0, 10);
      data.bullentinCatId = Number(data.bullentinCatId);
      that.titleId = data.bullentinCatId;
      console.log(that.titleId);
      var typeInfo = that.newsType(data.bullentinCatId);
      // console.log(data.bullentinCatId);
      // console.log(that.titleId);
      if (that.titleId == 6) {
        that.small = that.titleFour;
      } else if (that.titleId == 5) {
        that.small = that.titleThree;
      } else if (that.titleId == 4) {
        that.small = that.titleTwo;
      } else if (that.titleId == 3) {
        that.small = that.titleOne;
      }
      var style = "";
      var url = "javascript:;";
      var bid = "";
      var pageStyle = "";
      if (action) {
        style = "opacity:0;";
      }
      if (data.urlLink) {
        url = data.urlLink;
        bid = data.bullentinId;
      } else {
        url = "news-detail?id=" + data.bullentinId;
        bid = data.bullentinId;
      }
      if (page == "home") {
        pageStyle = "main__news";
      }
      if (page == "news") {
        pageStyle = "news-content";
      }
      var newsHTML =
        '<li class="' +
        pageStyle +
        '__li" style="' +
        style +
        '">\
                <a href="' +
        url +
        '" class="' +
        pageStyle +
        "__link " +
        typeInfo.class +
        '" data-bid="' +
        bid +
        '">\
                    <div class="' +
        pageStyle +
        '__info">\
                        <span class="' +
        pageStyle +
        '__info-time">' +
        SData +
        '</span>\
                        <span class="' +
        pageStyle +
        '__info-text">' +
        that.small +
        '</span>\
                    </div>\
                    <div class="' +
        pageStyle +
        '__title">\
                        <span class="' +
        pageStyle +
        '__title-text">' +
        data.title +
        "</span>\
                    </div>\
                </a>\
             </li >\
        ";
      return newsHTML;
    }
  }
};
</script>
<style scoped></style>
